import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../../services/partner.service';
import { HelpersService } from '../../../../services/helpers.service';
import { AddEditUserComponent } from '../../../modals/add-edit-user/add-edit-user.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  public partnerID: string;
  public loading: boolean = true;
  public users: any = [];
  public technicians: any = [];
  public columns: any = [
    {
      header: this.translate.instant('general.headers.firstname'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.surname'),
      field: 'Surname',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.email'),
      field: 'Email',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.system_view'),
      field: 'TechnicianID',
      type: 'technician',
    },
    {
      header: this.translate.instant('general.headers.technician_status'),
      field: 'IsActive',
      type: 'technician_status',
    },
  ];

  constructor(
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    private translate: TranslateService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.getUsers();
  }

  getUsers() {
    this.loading = true;
    this.partnerService.getPartnerUsers(this.partnerID).subscribe((users) => {
      this.getTechnicians(users);
    });
  }

  getTechnicians(users) {
    this.partnerService
      .getPartnerTechnicians(this.partnerID)
      .subscribe((technicians) => {
        this.loading = false;
        this.technicians = technicians;
        this.users = users;
        let user_ids = this.users.map((user) => {
          return user.ID;
        });
        technicians.forEach((technician) => {
          let user = this.users[user_ids.indexOf(technician.UserID)];
          if (technician.UserID === 0 || !user) {
            technician.Name = technician.Firstname; //Just so the View works...not Ideal but hey :)
            this.users.push(technician);
          } else {
            user.Technician = technician;
          }
        });
      });
  }

  addUser() {
    const modalRef = this.modalService.open(AddEditUserComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.partnerId = this.partnerID;
    modalRef.componentInstance.user = {};
    modalRef.componentInstance.users = this.users;
    modalRef.componentInstance.update.subscribe(() => {
      this.getUsers();
    });
    modalRef.componentInstance.technicians = this.technicians;
    modalRef.result.then(
      (result) => {
        this.getUsers();
      },
      (onrejected) => {
        this.getUsers();
      },
    );
  }

  editUser(user) {
    const modalRef = this.modalService.open(AddEditUserComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.partnerId = this.partnerID;
    modalRef.componentInstance.user = user;
    modalRef.componentInstance.users = this.users;
    modalRef.componentInstance.update.subscribe(() => {
      this.getUsers();
    });
    modalRef.componentInstance.technicians = this.technicians;
    modalRef.result.then(
      (result) => {
        this.getUsers();
      },
      (onrejected) => {
        this.getUsers();
      },
    );
  }
}
